import React from 'react';

import TextFeedbackRow from 'pages/open-course/peerReview/components/TextFeedbackRow';
import TextFeedbackTable from 'pages/open-course/peerReview/components/TextFeedbackTable';
import Review from 'pages/open-course/peerReview/reviewTypes/structured/models/review';
import ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/singleLineInput/models/schema';

import Content from 'bundles/phoenix/components/Content';

import 'css!./__styles__/SingleLineInputDisplayPart';

const ReviewRow = ({ reviewSchemaPart, review }: $TSFixMe) => {
  const partId = reviewSchemaPart.get('id');
  const reviewInput = review.get('parts').get(partId).get('input');
  const reviewCreator = review.get('creator');
  return (
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'creatorScore' is missing in type '{ chil... Remove this comment to see the full error message
    <TextFeedbackRow
      isAnonymous={reviewCreator.get('isAnonymous')}
      creatorFullName={reviewCreator.get('fullName')}
      creatorPhotoUrl={reviewCreator.get('photoUrl')}
    >
      <span className="review-text">{reviewInput}</span>
    </TextFeedbackRow>
  );
};

class SingleLineInputDisplayPart extends React.Component {
  static propTypes = {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
    reviewSchemaPart: React.PropTypes.instanceOf(ReviewSchemaPart).isRequired,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
    reviews: React.PropTypes.arrayOf(React.PropTypes.instanceOf(Review)).isRequired,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reviewSchemaPart' does not exist on type... Remove this comment to see the full error message
    const { reviewSchemaPart, reviews } = this.props;

    return (
      <div className="rc-SingleLineInputDisplayPart">
        <Content content={reviewSchemaPart.get('prompt')} />
        <TextFeedbackTable>
          {reviews.map((review: $TSFixMe) => (
            <ReviewRow key={review.get('id')} reviewSchemaPart={reviewSchemaPart} review={review} />
          ))}
        </TextFeedbackTable>
      </div>
    );
  }
}

export default SingleLineInputDisplayPart;
